import { render, staticRenderFns } from "./SummaryDetails.vue?vue&type=template&id=d8675b34&scoped=true"
import script from "./SummaryDetails.vue?vue&type=script&lang=js"
export * from "./SummaryDetails.vue?vue&type=script&lang=js"
import style0 from "./SummaryDetails.vue?vue&type=style&index=0&id=d8675b34&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8675b34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8675b34')) {
      api.createRecord('d8675b34', component.options)
    } else {
      api.reload('d8675b34', component.options)
    }
    module.hot.accept("./SummaryDetails.vue?vue&type=template&id=d8675b34&scoped=true", function () {
      api.rerender('d8675b34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/data/components/Balance/SummaryDetails.vue"
export default component.exports